<div [ngStyle]="mainStyles">
    <span class="header"
          mat-dialog-title>
        <span class="header__title">{{ title }}</span>
        <button class="header__close"
                *ngIf="closeVisible"
                type="button"
                mat-button
                color="accent"
                (click)="close()">
            <mat-icon class="mdi-18px"
                      svgIcon="mdi:close">
            </mat-icon>
        </button>
    </span>
    <mat-dialog-content class="content">
        <div class="content__message"
             [ngStyle]="styles"
             [innerHTML]="message">
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button *ngFor="let choice of choices"
                mat-button
                [color]="getColor(choice)"
                (click)="OnButtonClick(choice)">{{ getChoice(choice) }}</button>
    </mat-dialog-actions>
</div>